import {Component} from 'react';
import {Link, Navigate} from "react-router-dom";
import config from "../config.json";

class WineList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            wines: [],
            goToLogin: false
        };
        this.getWineList = this.getWineList.bind(this);
    }

    componentDidMount() {
        this.getWineList();
    }

    getWineList = () => {
        fetch(config.serverUrl_local + `/wine/wines/0/100`, {credentials: 'include'})
            .then(async response => {
                const data = await response.json();
                // check for error response
                this.setState({
                    wines: data.content,
                    goToLogin: response.status === 400
                })
            })
            .catch(error => {
                this.setState({errorMessage: error.toString()});
                console.error('There was an error!', error);
            });
    }

    render() {
        return <>
            {this.state.goToLogin && (
                <Navigate to="/" replace={true}/>
            )}
            <div className="container">
                <div className="d-flex flex-column align-items-center justify-content-center vh-100 ">
                    <div className="col-md-10 col-lg-offset-1 ">
                        <fieldset className="fieldset-custom border p-3">
                            <div className="header-logo align-bottom">
                                <legend className="w-auto">Le vin est un voyage</legend>
                            </div>
                            {/*<legend className="w-auto">Vos vins</legend>*/}
                            <div className="container-list">
                                <table className="table table-custom">
                                    <thead>
                                    <tr>
                                        <th scope="col">Nom du vin</th>
                                        <th scope="col">Lien Xeniagraphy</th>
                                        <th scope="col">QR code</th>
                                        <th scope="col">Affiche pdf</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.wines && this.state.wines.map((wine, i) => {
                                        const qr = config.serverUrl_local + '/' + wine.qrUrl;
                                        const pdfUrl = config.serverUrl_local + '/' + wine.pdfUrl;
                                        return <tr key={i}>
                                            <td>{wine.title}</td>
                                            <td><a target="_blank" rel="noreferrer" href={wine.widgetUrl}>Ouvrir</a>
                                            </td>
                                            <td><a target="_blank" rel="noreferrer" href={qr}>QR code</a></td>
                                            <td><a href={pdfUrl}>Télécharger</a></td>
                                        </tr>
                                    })}
                                    </tbody>
                                </table>
                            </div>
                            <Link to="/new-entry" className="btn btn-primary  m-4">Ajouter nouveau vin</Link>
                            <div className="m-1">
                                <a href="mailto:contact@laleph.com">Besoin d’aide?</a>
                            </div>

                        </fieldset>
                    </div>
                </div>
            </div>
        </>
    }
}

export default WineList